<template>

  <v-container fluid class="pa-0" style="background:#f6f6f6;height:1500px">

    <v-row align="center" style="background:#ffffff" justify="end" dense no-gutters>
        <v-col md="1" sm="12" xs="12">
          <label class="menunamestyle ml-5">{{this.$session.get("MENUNAME")}}</label>
        </v-col>
        <v-spacer/>
        <template v-if="grade >= 50">
          <v-col md="3" sm="12" xs="12" >
            <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
          </v-col>
          <v-col md="3" sm="12" xs="12" >
            <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
          </v-col>
          <v-col md="3" sm="12" xs="12" >
            <optiondialog :optionname="SEARCH_OPTION_NAME" :comidx="SEARCH_COM_IDX" :eventidx="SEARCH_EVENT_IDX" @callback="optionsearchcb"></optiondialog>
          </v-col>
        </template>
        <template v-else>
          <v-col md="3" sm="12" xs="12" >
            <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
          </v-col>
          <v-col md="3" sm="12" xs="12" >
            <optiondialog :optionname="SEARCH_OPTION_NAME" :comidx="SEARCH_COM_IDX" :eventidx="SEARCH_EVENT_IDX" @callback="optionsearchcb"></optiondialog>
          </v-col>
        </template>
        <v-col cols="2" md="2" sm="12" xs="12" >
          <v-btn class="search_btn_freesize" outlined large @click="loadpage">{{$t('common_search_list')}}</v-btn>
        </v-col>
    </v-row>

    <v-row dense no-gutters>
      <v-col cols="12" style="background:#f6f6f6;border-width:1px 1px 1px 1px;border-color:#f5f5f5;border-radius:1px;border-style:solid;"/>
    </v-row>

    <v-row>
      <v-col cols="12" md="9" style="border-width:1px 1px 1px 1px;border-color:#f5f5f5;border-radius:1px;border-style:solid;">

        <v-row ref="edit_layout" justify="start" dense no-gutters>

          <v-row dense class="ml-3">
            <v-col cols="3">
              <v-text-field background-color="white" dense outlined height="43" ref="ref_diswidth" :value="DISPLAY_WIDTH" :label="$t('design_label1')" @keydown.enter="changedisplay"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field background-color="white" dense outlined height="43" ref="ref_disheight" :value="DISPLAY_HEIGHT" :label="$t('design_label2')" @keydown.enter="changedisplay"></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn class="white_blue_btn mr-1" outlined large @click="changedisplay">{{$t('design_label3')}}</v-btn>
            </v-col>
          </v-row>

          <v-spacer/>
          <v-btn :disabled="SEARCH_OPTION_IDX == null" class="white_blue_btn mr-1" outlined large @click="savedesign" ><v-icon>mdi-download</v-icon>{{$t("common_save")}}</v-btn>
          <v-btn :disabled="SEARCH_OPTION_IDX == null" class="white_blue_btn mr-5" outlined large @click="printtest4040" ><v-icon>mdi-printer</v-icon>{{$t('design_label4')}}</v-btn>
        </v-row>

        <!-- 저장 완료 Toast -->
        <v-snackbar
          v-model="showSaveSnackbar"
          timeout="3000"
          color="success"
          top
        >
          {{$t('design_msg3')}}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="showSaveSnackbar = false"
            >
            </v-btn>
          </template>
        </v-snackbar>

        <v-row class="mt-5" justify="center" dense no-gutters :style="'z-index:10;position:fixed; top:170px;left:'+(DISPLAY_X+20)+'px'">

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="SEARCH_OPTION_IDX == null" icon color="#505050" @click="addcomponent" v-bind="attrs" v-on="on"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
              </template>
              <span>{{$t("common_insert")}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="SEARCH_OPTION_IDX == null || SELECT_ITEM.length == 0 || SELECT_ITEM[0].ISBG == 1" icon color="#505050" @click="rotateComponent" v-bind="attrs" v-on="on"><v-icon>mdi-rotate-right</v-icon></v-btn>
              </template>
              <span>{{$t("common_rotate")}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="SEARCH_OPTION_IDX == null" icon color="#505050" @click="centeralign" v-bind="attrs" v-on="on"><v-icon>mdi-align-horizontal-center</v-icon></v-btn>
              </template>
              <span>{{$t('design_label5')}}</span>
            </v-tooltip>
            
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="SEARCH_OPTION_IDX == null" icon color="#505050" @click="fullsize" v-bind="attrs" v-on="on"><v-icon>mdi-arrow-split-vertical</v-icon></v-btn>
              </template>
              <span>{{$t('design_label6')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="SEARCH_OPTION_IDX == null" icon color="#505050" @click="getfront" v-bind="attrs" v-on="on"><v-icon>mdi-arrange-bring-forward</v-icon></v-btn>
              </template>
              <span>{{$t('design_label7')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="SEARCH_OPTION_IDX == null" icon color="#505050" @click="pushback" v-bind="attrs" v-on="on"><v-icon>mdi-arrange-send-backward</v-icon></v-btn>
              </template>
              <span>{{$t('design_label8')}}</span>
            </v-tooltip>
          
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="SEARCH_OPTION_IDX == null" icon color="#505050" @click="deleteall" v-bind="attrs" v-on="on"><v-icon>mdi-autorenew</v-icon></v-btn>
              </template>
              <span>{{$t('design_label9')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="SEARCH_OPTION_IDX == null" icon color="#505050" @click="deletedesign" v-bind="attrs" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
              </template>
              <span>{{$t('design_label10')}}</span>
            </v-tooltip>
          
        </v-row>

        <v-row :style="'position:fixed; top:230px;left:'+(DISPLAY_X+30)+'px'">
          <a id="edit_div_label1" class="front_info_label" @click="selectface(true)">{{$t('design_label11')}}</a>
          <div style="width:10px"/>
          <a id="edit_div_label2" class="back_info_label"  @click="selectface(false)">{{$t('design_label12')}}</a>
        </v-row>

        
        <v-row dense no-gutters  justify="center" class="edit_area">
            <div id="edit_div_line" class="face-border face-active" :style="'margin-left:20px;width:'+(DISPLAY_WIDTH+6)+'px;height:'+(DISPLAY_HEIGHT+6)+'px;backgroundColor:#808080;overflow:auto;position:absolute;'">
              <div id="edit_div" :style="'width:'+DISPLAY_WIDTH+'px;height:'+DISPLAY_HEIGHT+'px;backgroundColor:#808080;overflow:hidden;position:absolute;'">
              </div>
            </div> 
            <div id="edit_div_line2" class="face-border face-inactive" :style="'margin-bottom:100px;margin-left:20px;margin-top:'+(DISPLAY_HEIGHT+40)+'px;width:'+(DISPLAY_WIDTH+6)+'px;height:'+(DISPLAY_HEIGHT+6)+'px;backgroundColor:#808080;overflow:auto;position:absolute;'">
              <div id="edit_div2" :style="'width:'+DISPLAY_WIDTH+'px;height:'+DISPLAY_HEIGHT+'px;backgroundColor:#808080;overflow:hidden;position:absolute;'">
              </div>
            </div>  
        </v-row>  


      </v-col>

      <v-col cols="12" md="3" style="background:#ffffff;"  v-if="SEARCH_OPTION_IDX != null">
        <div style="overflow:auto" v-if="SELECT_ITEM.length > 0">
        <v-row dense no-gutters >
          <v-col cols="12">
            <comlayout @callback="selectlayout_com"/>
          </v-col>
          <v-col cols="12">
            <comdesignuser @callback="selectdesign_com"/>
          </v-col>
        </v-row>

        <v-row dense justify="center">
        </v-row>
        <template v-if="SELECT_ITEM.length > 0 && SELECT_ITEM[0].ISBG == 0">
          <v-row dense class="mt-2 ml-5 mr-5">
            <v-select outlined dense :value="SELECT_ITEM[0].COMPONENT_TYPE" 
            @change="changecomponenttype" :items="COMPONENTTYPELIST" :label="$t('design_label13')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
          </v-row>
        </template>
        <v-row dense class="mt-2 ml-5 mr-5">
          <v-select outlined dense :value="SELECT_ITEM[0].BGTYPE" @change="changebgtype" 
            :items="BGTYPELIST" :label="$t('design_label14')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
        </v-row>

        <template v-if="SELECT_ITEM[0].BGTYPE == 1">
          <v-row dense class="ml-5 mr-5">
            <v-file-input outlined dense accept="image/*" :label="$t('design_label15')" v-model="uploadFile" @change="changefile">
              <!-- <template v-slot:selection>{{ SELECT_ITEM[0].LOCALIMG }}</template> -->
            </v-file-input>
            <template v-if="SELECT_ITEM[0].LOCALIMG != null ">
              <v-btn class="search_btn" small rounded color="primary" @click="uploadimage">{{$t("common_save")}}</v-btn>
            </template>
          </v-row>
        </template>

        <v-row dense class="ml-5 mr-5">
          <comcolor :disabled="SELECT_ITEM[0].BGTYPE == 1" dense ref="bgcolor" :comname="$t('design_label16')" :colorvalue="SELECT_ITEM[0].BGCOLOR" @callback="bgcolorcallback" />
        </v-row>

          <v-row dense class="ml-5 mr-5">
            <comcolor :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" dense ref="textcolor" :comname="$t('design_label17')" :colorvalue="SELECT_ITEM[0].TEXTCOLOR" @callback="textcolorcallback" />
          </v-row>

          <!-- 
          <v-row v-if="grade > 90 && SELECT_ITEM[0].ISBG == 0" dense class="ml-5 mr-5">
            <v-checkbox :label="$t('design_label18')" v-model="SELECT_ITEM[0].ISFLIP" @change="changeflip"></v-checkbox>
          </v-row>
          -->

          <v-row dense class="ml-5 mr-5 mt-2">
            <v-select outlined :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" dense :value="SELECT_ITEM[0].TEXTALIGN"  @change="changealign" :items="ALIGNTYPELIST" :label="$t('design_label19')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
          </v-row>
          <v-row dense class="ml-2 mr-5">
            <comfont  :comidx="this.SEARCH_COM_IDX" outlined :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :comname="SELECT_ITEM[0].TEXTFONT" @callback="changefont"/>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_textsize" :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :value="SELECT_ITEM[0].TEXTSIZE" :label="$t('design_label20')" @keydown.enter="changesize"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" class="ml-2 search_btn" @click="changesize">{{$t('design_label21')}}</v-btn>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-select outlined dense :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :value="SELECT_ITEM[0].TEXTMATCH"  @change="changematch" :items="MATCHTYPELIST" :label="$t('design_label22')" item-text="name" item-value="value"/>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-textarea dense outlined height="70" ref="ref_textvalue" :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0 || SELECT_ITEM[0].TEXTMATCH != 'INPUT'"
                :value="SELECT_ITEM[0].TEXTVALUE" :label="$t('design_label23')" @keydown.enter="changevalue" no-resize></v-textarea>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" class="ml-2 search_btn" @click="changevalue">{{$t('design_label21')}}</v-btn>
          </v-row>

          <!-- 
          <v-row dense class="ml-5 mr-5">
            <v-col cols="12" class="ma-0 pa-0">
              <label>자간</label>
              <input 
                v-model="SELECT_ITEM[0].LETTER_SPACING" 
                style="width:50px;font-size:12px;border: solid 1px gray;border-radius:3px;text-align:center"
                />
            </v-col>
            <v-col class="ma-0 pa-0">
              <v-slider v-model="SELECT_ITEM[0].LETTER_SPACING" min="0" max="500"/>
            </v-col>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col cols="12" class="ma-0 pa-0">
              <label>줄간격</label>
              <input 
                v-model="SELECT_ITEM[0].LINE_HEIGHT" 
                style="width:50px;font-size:12px;border: solid 1px gray;border-radius:3px;text-align:center"
                />
            </v-col>
            <v-col class="ma-0 pa-0">
              <v-slider v-model="SELECT_ITEM[0].LINE_HEIGHT" min="50" max="500"/>
            </v-col>
          </v-row>
          -->


          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_posx" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_POSX" :label="$t('design_label24')" @keydown.enter="changeposx"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn"  @click="changeposx">{{$t('design_label21')}}</v-btn>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_posy" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_POSY" :label="$t('design_label25')" @keydown.enter="changeposy"/>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" elevation="0" outlined large  @click="changeposy">{{$t('design_label21')}}</v-btn>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_width" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_WIDTH" :label="$t('design_label26')" @keydown.enter="changewidth"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn"  @click="changewidth">{{$t('design_label21')}}</v-btn>
          </v-row>
          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_height" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_HEIGHT" :label="$t('design_label27')" @keydown.enter="changeheight"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changeheight">{{$t('design_label21')}}</v-btn>
          </v-row>

          <v-row dense class="ml-5 mr-5">
            <v-col class="ma-0 pa-0">
              <v-text-field dense outlined height="43" ref="ref_rotate" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].ROTATE" :label="$t('design_label28')" @keydown.enter="changerotate"></v-text-field>
            </v-col>
            <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changerotate">{{$t('design_label21')}}</v-btn>
          </v-row>

        </div>
      </v-col>
    </v-row>

    <v-row class="mt-15" />


  </v-container>
</template>

<script>
import DRBackground from '../dragndrop/DRBackground2.js'
// eslint-disable-next-line no-unused-vars
import DRComponent from '../dragndrop/DRComponent2.js'
import DRModel from '../dragndrop/DRModel.js'
  
  export default {

    methods: {

      changelayoutsize(){
        this.DISPLAY_X = this.$refs.edit_layout.getBoundingClientRect().x;
      },

      unloadevent:function(event){
        event.preventDefault();
        event.returnValue = "";
      },



      fullsize(){
        if(this.isfront){
          this.drback.fullsize();
        }else{
          this.drback2.fullsize();
        }
      },

      centeralign(){
        if(this.isfront){
          this.drback.centeralign();
        }else{
          this.drback2.centeralign();
        }
      },

      getfront(){
        if(this.isfront){
          this.drback.getfront();
        }else{
          this.drback2.getfront();
        }
      },

      pushback(){
        if(this.isfront){
          this.drback.pushback();
        }else{
          this.drback2.pushback();
        }
      },

      //언두 때문에 양방향 바인딩을 안쓴다. 버튼을 눌렀을 때 처리함. 엔터도 문제됨.
      changeposx(){
        let inputEl = this.$refs.ref_posx.$el.querySelector('input');
        var ev = inputEl.value;
        this.saveUndoCurrentFace();
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_POSX = 0;
          this.SELECT_ITEM[0].TEMP_POSX = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_POSX = parseInt(ev);
          this.SELECT_ITEM[0].TEMP_POSX = parseInt(ev);
        }
        this.updateCurrentFace();
      },

      changeposy(){
        let inputEl = this.$refs.ref_posy.$el.querySelector('input');
        var ev = inputEl.value;
        this.saveUndoCurrentFace();
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_POSY = 0;
          this.SELECT_ITEM[0].TEMP_POSY = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_POSY = parseInt(ev);
          this.SELECT_ITEM[0].TEMP_POSY = parseInt(ev);
        }
        this.updateCurrentFace();
      },

      changewidth(){
        let inputEl = this.$refs.ref_width.$el.querySelector('input');
        var ev = inputEl.value;
        this.saveUndoCurrentFace();
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_WIDTH = 0;
          this.SELECT_ITEM[0].TEMP_WIDTH = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_WIDTH = parseInt(ev);
          this.SELECT_ITEM[0].TEMP_WIDTH = parseInt(ev);
        }
        // 너비/높이 변경시 updateTransElementAll 호출
        const selectedComponents = this.isfront ? this.drback.selecto.getSelectedTargets() : this.drback2.selecto.getSelectedTargets();
        selectedComponents.forEach(cm=>{
            cm.updateTransElementAll();
        });
        // Moveable 업데이트
        if(this.isfront && this.drback.moveable && selectedComponents.length > 0){
          this.drback.moveable.updateRect();
        } else if(!this.isfront && this.drback2.moveable && selectedComponents.length > 0){
          this.drback2.moveable.updateRect();
        }
      },

      changeheight(){
        let inputEl = this.$refs.ref_height.$el.querySelector('input');
        var ev = inputEl.value;
        this.saveUndoCurrentFace();
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_HEIGHT = 0;
          this.SELECT_ITEM[0].TEMP_HEIGHT = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_HEIGHT = parseInt(ev);
          this.SELECT_ITEM[0].TEMP_HEIGHT = parseInt(ev);
        }
        // 너비/높이 변경시 updateTransElementAll 호출
        const selectedComponents = this.isfront ? this.drback.selecto.getSelectedTargets() : this.drback2.selecto.getSelectedTargets();
        selectedComponents.forEach(cm=>{
            cm.updateTransElementAll();
        });
        // Moveable 업데이트
        if(this.isfront && this.drback.moveable && selectedComponents.length > 0){
          this.drback.moveable.updateRect();
        } else if(!this.isfront && this.drback2.moveable && selectedComponents.length > 0){
          this.drback2.moveable.updateRect();
        }
      },

      changerotate(){
        let inputEl = this.$refs.ref_rotate.$el.querySelector('input');
        var ev = inputEl.value;
        this.saveUndoCurrentFace();
        if(isNaN(parseFloat(ev))){
          this.SELECT_ITEM[0].ROTATE = 0;
        }else{
          this.SELECT_ITEM[0].ROTATE = parseFloat(ev);
        }
        this.updateCurrentFace();
      },

      rotateComponent(){
        if(this.SELECT_ITEM.length > 0 && this.SELECT_ITEM[0].ISBG != 1){
          this.saveUndoCurrentFace();
          // 현재 회전값에서 90도씩 추가 (360도 넘으면 0부터 시작)
          let currentRotate = this.SELECT_ITEM[0].ROTATE || 0;
          this.SELECT_ITEM[0].ROTATE = (currentRotate + 90) % 360;
          this.updateCurrentFace();
          this.$forceUpdate(); // 화면 갱신
        }
      },

      // Del 키 이벤트 핸들러
      handleKeyDown(event){
        // Del 키 또는 Delete 키가 눌렸을 때
        if(event.key === 'Delete' && this.SELECT_ITEM.length > 0 && this.SELECT_ITEM[0].ISBG != 1){
          event.preventDefault(); // 기본 동작 방지
          this.deletedesign(); // 기존 삭제 메서드 호출
        }
      },



      changedisplay(){
        let inputEl1 = this.$refs.ref_diswidth.$el.querySelector('input');
        var ev1 = inputEl1.value;
        if(isNaN(parseInt(ev1))){
          this.DISPLAY_WIDTH = 0;
        }else{
          this.DISPLAY_WIDTH = parseInt(ev1);
        }
        let inputEl2 = this.$refs.ref_disheight.$el.querySelector('input');
        var ev2 = inputEl2.value;
        if(isNaN(parseInt(ev2))){
          this.DISPLAY_HEIGHT = 0;
        }else{
          this.DISPLAY_HEIGHT = parseInt(ev2);
        }

        
        this.drback.setLayoutChange(this.DISPLAY_WIDTH, this.DISPLAY_HEIGHT);
        this.drback2.setLayoutChange(this.DISPLAY_WIDTH, this.DISPLAY_HEIGHT);
        this.drback.updateComponent();
        this.drback2.updateComponent();
      },



      changevalue(){
        let inputEl = this.$refs.ref_textvalue.$el.querySelector('textarea');
        var ev = inputEl.value;
        this.saveUndoCurrentFace();
        this.SELECT_ITEM[0].TEXTVALUE = ev;
        this.updateCurrentFace();
      },

      changesize(){
        let inputEl = this.$refs.ref_textsize.$el.querySelector('input');
        var ev = inputEl.value;
        if(ev < 10){
          this.$alert(this.$t('design_msg1'));
          inputEl.value = this.SELECT_ITEM[0].TEXTSIZE;
          return;
        }
        this.saveUndoCurrentFace();
        this.SELECT_ITEM[0].TEXTSIZE = parseInt(ev);
        this.updateCurrentFace();
      },
      
      changealign(ev){
        this.saveUndoCurrentFace();
        this.SELECT_ITEM[0].TEXTALIGN = ev;
        this.updateCurrentFace();
      },
      changematch(ev){
        this.saveUndoCurrentFace();
        this.SELECT_ITEM[0].TEXTMATCH = ev;
        this.updateCurrentFace();
      },

      changefont(cl){
        //폰트 변경
        this.saveUndoCurrentFace();
        this.SELECT_ITEM[0].TEXTFONT = cl.CODE;
        this.updateCurrentFace();
        this.$forceUpdate();
      },

      changebgtype(cl){
        if(this.SELECT_ITEM[0].ISBG == 1){
          //배경 언두 처리
          if(this.isfront){
            this.drback.saveBGUndo("bginfo");
          }else{
            this.drback2.saveBGUndo("bginfo");
          }
          this.SELECT_ITEM[0].BGTYPE = cl;
          if(this.isfront){
            this.drback.updateBackground(this.SELECT_ITEM[0]);
          }else{
            this.drback2.updateBackground(this.SELECT_ITEM[0]);
          }
        }else{
          this.saveUndoCurrentFace();
          this.SELECT_ITEM[0].BGTYPE = cl;
          this.updateCurrentFace();
        }
      },

      changeflip(){
        this.saveUndoCurrentFace();
        this.updateCurrentFace();
      },

      changecomponenttype(cl){
        this.saveUndoCurrentFace();
        this.SELECT_ITEM[0].COMPONENT_TYPE = cl;
        this.updateCurrentFace();
      },

      bgcolorcallback(cl){

        if(this.SELECT_ITEM[0].ISBG == 1){
          //배경 언두 처리
          if(this.isfront){
            this.drback.saveBGUndo("bginfo");
          }else{
            this.drback2.saveBGUndo("bginfo");
          }

          this.SELECT_ITEM[0].BGCOLOR = String(cl).replace("#","");

          if(this.isfront){
            this.drback.updateBackground(this.SELECT_ITEM[0]);
          }else{
            this.drback2.updateBackground(this.SELECT_ITEM[0]);
          }

        }else{
          //언두 저장
          this.saveUndoCurrentFace();
          
          this.SELECT_ITEM[0].BGCOLOR = String(cl).replace("#","");

          this.updateCurrentFace();
        }

      },

      textcolorcallback(cl){
        //미리 undo를 백업해야함.
        this.saveUndoCurrentFace();

        this.SELECT_ITEM[0].TEXTCOLOR = String(cl).replace("#","");
        this.updateCurrentFace();
      },


      //DRBackground가 호출함.
      colorupdate(){
        try{
          this.$refs.bgcolor.updatecolor(this.SELECT_ITEM[0].BGCOLOR);
          this.$refs.textcolor.updatecolor(this.SELECT_ITEM[0].TEXTCOLOR);
        // eslint-disable-next-line no-empty
        }catch(e){
        }
        //이미지
        this.uploadFile = null;
        this.uploadFile = this.SELECT_ITEM[0].LOCALIMG;
        this.$forceUpdate();
      },

      //DRBackground가 호출함.
      selectitem(item){
        // 기존 배열을 완전히 비우고 새 아이템 추가
        this.SELECT_ITEM.splice(0, this.SELECT_ITEM.length);
        this.SELECT_ITEM.push(item);
      },

      // 현재 활성 면에만 언두 저장하는 헬퍼 함수
      saveUndoCurrentFace(type = "info"){
        if(this.isfront){
          this.drback.saveUndo(type);
        }else{
          this.drback2.saveUndo(type);
        }
      },

      // 현재 활성 면만 업데이트하는 헬퍼 함수
      updateCurrentFace(){
        if(this.isfront){
          this.drback.updateComponent();
        }else{
          this.drback2.updateComponent();
        }
      },


      //DRBackground가 호출함. true면 앞면 false면 뒷면
      selectface(flag){
        const edit_div_line  = document.getElementById("edit_div_line");
        const edit_div_line2 = document.getElementById("edit_div_line2");
        const edit_div_label1 = document.getElementById("edit_div_label1");
        const edit_div_label2 = document.getElementById("edit_div_label2");
        
        if(flag){
          this.isfront = true;
          this.CURRENT_FACE = true;  // 현재 활성 면 설정
          
          // 앞면 활성화
          edit_div_line.classList.remove('face-inactive');
          edit_div_line.classList.add('face-active');
          
          // 뒷면 비활성화
          edit_div_line2.classList.remove('face-active');
          edit_div_line2.classList.add('face-inactive');
          
          edit_div_label1.className = "front_info_label";
          edit_div_label2.className = "back_info_label";
          this.drback2.selectCancel();  //프론트 선택시 백 모든 선택 취소
        }else{
          this.isfront = false;
          this.CURRENT_FACE = false;  // 현재 활성 면 설정
          
          // 앞면 비활성화
          edit_div_line.classList.remove('face-active');
          edit_div_line.classList.add('face-inactive');
          
          // 뒷면 활성화
          edit_div_line2.classList.remove('face-inactive');
          edit_div_line2.classList.add('face-active');
          
          edit_div_label1.className = "back_info_label";
          edit_div_label2.className = "front_info_label";
          this.drback.selectCancel();  //백선택시 프론트 모든 선택 취소
        }

      },

      savedesign(){
        console.log("savedesign 호출됨");
        console.log("drback:", this.drback);
        console.log("drback2:", this.drback2);
        
        //로컬이미지가 있다면 저장 불가.
        var flag = true;
        if(this.drback.model.LOCALIMG != null){
          flag = false;
        }
        if(this.drback2.model.LOCALIMG != null){
          flag = false;
        }
        if(!flag){
          this.$alert(this.$t('design_msg2'));
          return;
        }
        for(var j=0;j<this.drback.component_list.length;j++){
          if(this.drback.component_list[j].model.LOCALIMG != null){
            flag = false;
            break;
          }
        }
        for(var k=0;k<this.drback2.component_list.length;k++){
          if(this.drback2.component_list[k].model.LOCALIMG != null){
            flag = false;
            break;
          }
        }
        if(!flag){
          this.$alert(this.$t('design_msg2'));
          return;
        }


        //뉴라인 특수문자 컨버트 처리
        this.drback.component_list.forEach(cm=>{
            //if(cm.model.COMPONENT_TYPE == 1 && cm.model.TEXTMATCH == "INPUT"){
            if(cm.model.COMPONENT_TYPE == 1){
              //console.log("convert1 : " + cm.model.TEXTVALUE.replaceAll("\n", "\\n"));
              cm.model.TEXTVALUE = cm.model.TEXTVALUE.replaceAll("\n", "\\n");
            }
        });
        this.drback2.component_list.forEach(cm=>{
            if(cm.model.COMPONENT_TYPE == 1){
              //console.log("convert2 : " + cm.model.TEXTVALUE.replaceAll("\n", "\\n"));
              cm.model.TEXTVALUE = cm.model.TEXTVALUE.replaceAll("\n", "\\n");
            }
        });

        
        //객체를 JSON으로 변환하는거 같은데 요고 바꾸자
        var temp_obj  = JSON.parse('{"data":[]}');
        var temp_obj2 = JSON.parse('{"data":[]}');
        
        //배경 컴포넌트 넣어주고
        temp_obj["data"].push(this.drback.model);
        this.drback.component_list.forEach(cm=>{
          temp_obj["data"].push(cm.model);
        });
        temp_obj2["data"].push(this.drback2.model);
        this.drback2.component_list.forEach(cm=>{
          temp_obj2["data"].push(cm.model);
        });
        
        //json 업로드 체크! - 원본 주석 풀어야한다.
        this.$http.post(this.$host+'/api/GuestDesignInsert',
          {
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , EVENT_IDX: this.SEARCH_EVENT_IDX
            , OPTION_IDX: this.SEARCH_OPTION_IDX
            , COMPONENT_WIDTH: this.DISPLAY_WIDTH
            , COMPONENT_HEIGHT: this.DISPLAY_HEIGHT
            , COMPONENT: escape(JSON.stringify(temp_obj).replaceAll('\n','\\n'))
            , COMPONENT2: escape(JSON.stringify(temp_obj2).replaceAll('\n','\\n'))
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          this.loading = false;

          

          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            
            //this.SELECT_DESIGN.COMPONENT   = temp_obj;
            //this.SELECT_DESIGN.COMPONENT2  = temp_obj2;
            this.showSaveSnackbar = true;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
            this.loading = false;
        });
        

      },

      deletedesign(){
        this.drback.removeComponent();
        this.drback2.removeComponent();
      },

      deleteall(){

          this.$confirm(this.$t('design_msg4'))
          .then(() => {

            this.$http.post(this.$host+'/api/GuestDesignDelete',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , EVENT_IDX : this.SEARCH_EVENT_IDX
              , OPTION_IDX : this.SEARCH_OPTION_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t('design_msg5')).then(()=>{
                
                //BG초기화
                var temp = [
                              {
                                COMPONENT:{ 
                                            data:[ 
                                                    {IMG:null,ISBG:1,SCALE:1,BGTYPE:0,ROTATE:0,ZINDEX:1,BGCOLOR:"FFFFFFFF",LOCALIMG:null,STEP_IDX:null,TEXTFONT:"나눔고딕",TEXTSIZE:20,ADMIN_IDX:null,EVENT_IDX:null,TEMP_POSX:0,TEMP_POSY:0,TEXTALIGN:"CENTER",TEXTCOLOR:"000000FF",TEXTMATCH:"INPUT",TEXTVALUE:this.$t('design_msg6'),TEMP_WIDTH:384,LAYOUT_POSX:0,LAYOUT_POSY:0,TEMP_HEIGHT:463,LAYOUT_WIDTH:384,LAYOUT_HEIGHT:463,COMPONENT_TYPE:1}
                                                  ]
                                }
                                ,COMPONENT2:{
                                            data:[
                                                    {IMG:null,ISBG:1,SCALE:1,BGTYPE:0,ROTATE:0,ZINDEX:1,BGCOLOR:"FFFFFFFF",LOCALIMG:null,STEP_IDX:null,TEXTFONT:"나눔고딕",TEXTSIZE:20,ADMIN_IDX:null,EVENT_IDX:null,TEMP_POSX:0,TEMP_POSY:0,TEXTALIGN:"CENTER",TEXTCOLOR:"000000FF",TEXTMATCH:"INPUT",TEXTVALUE:this.$t('design_msg6'),TEMP_WIDTH:384,LAYOUT_POSX:0,LAYOUT_POSY:0,TEMP_HEIGHT:463,LAYOUT_WIDTH:384,LAYOUT_HEIGHT:463,COMPONENT_TYPE:1}
                                                 ]
                                }
                              }
                            ];

                var tempobj2 = JSON.parse(JSON.stringify(temp)); //파싱
                this.SELECT_DESIGN = tempobj2[0];
                this.setFace();
                
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_fail"));
          });      


          });


      },

      changefile(){
        var file = this.uploadFile;
        if (file && file.type.match(/^image\/(png|jpeg)$/)) {

          //배경도 언두 처리 해줘야 하겠지..
          if(this.SELECT_ITEM[0].ISBG == 1){
            if(this.isfront){
              this.drback.saveBGUndo("bginfo");
            }else{
              this.drback2.saveBGUndo("bginfo");
            }
          }else{
            //미리 undo를 백업해야함.
            this.saveUndoCurrentFace();
          }

          var temp = window.URL.createObjectURL(file) //로컬 파일 경로를 가지고 이미지를 보여준다.
          this.SELECT_ITEM[0].IMG = temp;
          this.SELECT_ITEM[0].LOCALIMG = file; //blob 타입

          //갱신
          if(this.SELECT_ITEM[0].ISBG == 1){
            if(this.isfront){
              this.drback.updateBackground(this.SELECT_ITEM[0]);
            }else{
              this.drback2.updateBackground(this.SELECT_ITEM[0]);
            }
          }else{
            this.updateCurrentFace();
          }
          
        }
      },

      uploadimage(){

        if(this.SELECT_ITEM[0].LOCALIMG == null){
          this.$alert(this.$t('design_msg7'));
          return;
        }

        const formData = new FormData();
        formData.append("FOLDER", this.SEARCH_COM_IDX+"/guestdesign");
        formData.append("customfile", this.SELECT_ITEM[0].LOCALIMG);
        this.$http.post(this.$host+'/api/UploadImage', formData, {
          headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
        })
        .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            //성공
            const fileurl = result.data.resultData[0].fileurl;
            
            //변경
            this.SELECT_ITEM[0].IMG = fileurl;
            this.SELECT_ITEM[0].LOCALIMG = null;

            //갱신
            if(this.SELECT_ITEM[0].ISBG == 1){
              if(this.isfront){
                this.drback.updateBackground(this.SELECT_ITEM[0]);
              }else{
                this.drback2.updateBackground(this.SELECT_ITEM[0]);
              }
            }else{
              this.drback.updateComponent();
              this.drback2.updateComponent();
            }
            this.uploadFile = null;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }

        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
        });

      },

      addcomponent(){
        
        const cm = new DRModel();
        const cp = new DRComponent(cm, this.MATCHTYPELIST, false);
        
        if(this.isfront){
          this.drback.addComponent(cp, true);
        }else{
          this.drback2.addComponent(cp, true);
        }
        cp.setMatchTextValue();

      },

      loadpage(){
          
          this.SELECT_DESIGN = null;
          this.items.splice(0, this.items.length);   //데이터 초기화
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }
          if(this.SEARCH_OPTION_IDX == null){
            this.$alert(this.$t('design_msg8'));
            return;
          }

          this.loaddetail();

      },

      initpage(){
          //첫페이지 로드
          this.loadpage();
      },

      //행사 클릭 => 명찰 편집을 위한 준비 - 미리보기
      loaddetail(){

          //맵핑을 위한 행사입력양식 조회
          this.MATCHTYPELIST.splice(0, this.MATCHTYPELIST.length);   
          this.$http.post(this.$host+'/api/InputEventList',{
                ADMIN_IDX:  this.$session.get("ADMIN_IDX")
              , COM_IDX:    this.SEARCH_COM_IDX
              , EVENT_IDX : this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.useInfo = result.data.useData;
                const list = result.data.resultData;
                this.MATCHTYPELIST.push({name:this.$i18n.locale == 'ko' ? '직접입력' : 'Input', value:"INPUT"});
                list.forEach(element => {
                  if(element.USETYPE == 0){
                    this.MATCHTYPELIST.push({name: `${element.NAME} (${this.$t("eventinvit_msg7")})`, value:element.INPUT_CODE}); 
                  }else{
                    this.MATCHTYPELIST.push({name:element.NAME, value:element.INPUT_CODE}); 
                  }
                    
                });
                
                this.getInputCustom();

            }else if(result.data.resultCode == 2){
              //로그인 필요
              
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      getInputCustom(){
                    
          //명찰디자인 조회
          this.$http.post(this.$host+'/api/GuestDesignDetail',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , EVENT_IDX : this.SEARCH_EVENT_IDX
              , OPTION_IDX : this.SEARCH_OPTION_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              
              if(result.data.resultData.length == 0){
                //최초인 경우
                var temp = [
                            {
                                COMPONENT:{ 
                                            data:[ 
                                                    {IMG:null,ISBG:1,SCALE:1,BGTYPE:0,ROTATE:0,ZINDEX:1,BGCOLOR:"FFFFFFFF",LOCALIMG:null,STEP_IDX:null,TEXTFONT:"나눔고딕",TEXTSIZE:20,ADMIN_IDX:null,EVENT_IDX:null,TEMP_POSX:0,TEMP_POSY:0,TEXTALIGN:"CENTER",TEXTCOLOR:"000000FF",TEXTMATCH:"INPUT",TEXTVALUE:this.$t('design_msg6'),TEMP_WIDTH:384,LAYOUT_POSX:0,LAYOUT_POSY:0,TEMP_HEIGHT:463,LAYOUT_WIDTH:384,LAYOUT_HEIGHT:463,COMPONENT_TYPE:1}
                                                  ]
                                }
                                ,COMPONENT2:{
                                            data:[
                                                    {IMG:null,ISBG:1,SCALE:1,BGTYPE:0,ROTATE:0,ZINDEX:1,BGCOLOR:"FFFFFFFF",LOCALIMG:null,STEP_IDX:null,TEXTFONT:"나눔고딕",TEXTSIZE:20,ADMIN_IDX:null,EVENT_IDX:null,TEMP_POSX:0,TEMP_POSY:0,TEXTALIGN:"CENTER",TEXTCOLOR:"000000FF",TEXTMATCH:"INPUT",TEXTVALUE:this.$t('design_msg6'),TEMP_WIDTH:384,LAYOUT_POSX:0,LAYOUT_POSY:0,TEMP_HEIGHT:463,LAYOUT_WIDTH:384,LAYOUT_HEIGHT:463,COMPONENT_TYPE:1}
                                                 ]
                                }
                              }
                            ];

                var tempobj2 = JSON.parse(JSON.stringify(temp)); //파싱
                this.SELECT_DESIGN = tempobj2[0];
                this.DISPLAY_WIDTH  = 384;
                this.DISPLAY_HEIGHT = 463;

              }else{
                //로드한 경우
                var tempobj   = JSON.parse(JSON.stringify(result.data.resultData)); //파싱
                this.SELECT_DESIGN  = tempobj[0];
                this.DISPLAY_WIDTH  = this.SELECT_DESIGN.COMPONENT_WIDTH;
                this.DISPLAY_HEIGHT = this.SELECT_DESIGN.COMPONENT_HEIGHT;
                //console.log("res design : " + this.SELECT_DESIGN.EVENT_IDX);
              }
              this.setFace();

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              //BG초기화
              this.drback.clearBackground();
              this.drback2.clearBackground();
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              //BG초기화
              this.drback.clearBackground();
              this.drback2.clearBackground();
          });


      },

      //명찰의 앞면 뒷면 선택에 따른 미리보기 셋팅
      setFace(){
        //BG초기화
        this.drback.clearBackground();
        this.drback2.clearBackground();
        this.createComponent(this.drback,  this.SELECT_DESIGN.COMPONENT.data);
        this.createComponent(this.drback2, this.SELECT_DESIGN.COMPONENT2.data);
      },

      createComponent(bg, list){

        //컴포넌트 생성
        list.forEach(element => {
          
          const model = new DRModel();
          model.ADMIN_IDX     = element.ADMIN_IDX;
          model.EVENT_IDX     = element.EVENT_IDX;
          model.STEP_IDX      = element.STEP_IDX;
          model.IMG           = element.IMG;
          model.LOCALIMG      = null;
          model.ISBG          = element.ISBG;
          model.ISFLIP        = element.ISFLIP;
          model.BGTYPE        = element.BGTYPE;
          model.BGCOLOR       = element.BGCOLOR;
          model.TEXTCOLOR     = element.TEXTCOLOR;
          model.TEXTSIZE      = element.TEXTSIZE;
          model.TEXTFONT      = element.TEXTFONT;
          model.TEXTVALUE     = element.TEXTVALUE;
          model.TEXTALIGN     = element.TEXTALIGN;
          model.TEXTMATCH     = element.TEXTMATCH;
          model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
          model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
          model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
          model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);
          model.ROTATE       = element.ROTATE;

          model.TEMP_POSX   = model.LAYOUT_POSX;
          model.TEMP_POSY   = model.LAYOUT_POSY;
          model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
          model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;
          
          model.ZINDEX       = element.ZINDEX;
          model.COMPONENT_TYPE = element.COMPONENT_TYPE;

          //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
          if(element.ISBG == undefined || element.ISBG == null){
            if(element.LAYOUT_WIDTH == 384 && element.LAYOUT_POSX == 0 && element.LAYOUT_POSY == 0){
              model.ISBG = 1; //bg
              //bg는 this.drback에 직접 처리
              bg.updateBackground(model);
              return;
            }else{
              model.ISBG = 0; //컴포넌트
              if(element.COMPONENT_TYPE == undefined || element.COMPONENT_TYPE == null){
                if(element.TEXTVALUE != null && element.TEXTVALUE.length > 0){
                  model.COMPONENT_TYPE = 1; //text
                }else{
                  model.COMPONENT_TYPE = 0; //image
                }
              } 
            }
          }
          

          if(element.ISBG == 1){
              bg.updateBackground(model);
              return;
          }

          //컴포넌트 객체 생성.
          const component = new DRComponent(model, this.MATCHTYPELIST, false);
          bg.addComponent(component, false);

        });

      },


      selectdesign_com(item){
        this.SELECT_DESIGN = item;
        this.DISPLAY_WIDTH  = item.COMPONENT_WIDTH;
        this.DISPLAY_HEIGHT = item.COMPONENT_HEIGHT;
        this.setFace();
      },

      selectlayout_com(item){

          //부모뷰의 edit_div에 넣는다.
          this.$http.post(this.$host+'/api/LayoutDetail',
            {
                ADMIN_IDX : item.ADMIN_IDX
              , IDX : item.IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              var tempobj   = JSON.parse(JSON.stringify(result.data.resultData)); //파싱
              var component = tempobj[0].COMPONENT;
              this.DISPLAY_WIDTH  = tempobj[0].COMPONENT_WIDTH;
              this.DISPLAY_HEIGHT = tempobj[0].COMPONENT_HEIGHT;

              if(this.isfront){
                this.drback.clearBackground();
                this.createComponent(this.drback, component.data);
              }else{
                this.drback2.clearBackground();
                this.createComponent(this.drback2, component.data);
              }

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              //BG초기화
              this.drback.clearBackground();
              this.drback2.clearBackground();
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              //BG초기화
              this.drback.clearBackground();
              this.drback2.clearBackground();
          });


      },


      //출력용 컴포넌트 (input을 div로 생성)
      async createPrintComponent(bg, list){

        //컴포넌트 생성
        for(var i=0;i<list.length;i++){
          
          const element = list[i];

          const model = new DRModel();
          model.ADMIN_IDX     = element.ADMIN_IDX;
          model.EVENT_IDX     = element.EVENT_IDX;
          model.STEP_IDX      = element.STEP_IDX;
          model.IMG           = element.IMG;
          model.LOCALIMG      = null;
          model.ISBG          = element.ISBG;
          model.ISFLIP        = element.ISFLIP;
          model.BGTYPE        = element.BGTYPE;
          model.BGCOLOR       = element.BGCOLOR;
          model.TEXTCOLOR     = element.TEXTCOLOR;
          model.TEXTSIZE      = element.TEXTSIZE;
          model.TEXTFONT      = element.TEXTFONT;
          model.TEXTVALUE     = element.TEXTVALUE;
          model.TEXTALIGN     = element.TEXTALIGN;
          model.TEXTMATCH     = element.TEXTMATCH;
          model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
          model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
          model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
          model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);
          model.ROTATE        = element.ROTATE || 0;

          model.TEMP_POSX   = model.LAYOUT_POSX;
          model.TEMP_POSY   = model.LAYOUT_POSY;
          model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
          model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;

          model.ZINDEX        = element.ZINDEX;
          model.COMPONENT_TYPE = element.COMPONENT_TYPE;
          //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
          if(element.ISBG == undefined || element.ISBG == null){
            if(element.LAYOUT_WIDTH == 384 && element.LAYOUT_POSX == 0 && element.LAYOUT_POSY == 0){
              model.ISBG = 1; //bg
              //bg는 this.drback에 직접 처리
              bg.updateBackground(model);
              continue;
            }else{
              model.ISBG = 0;
              if(element.COMPONENT_TYPE == undefined || element.COMPONENT_TYPE == null){
                if(element.TEXTVALUE != null && element.TEXTVALUE.length > 0){
                  model.COMPONENT_TYPE = 1; //text
                }else{
                  model.COMPONENT_TYPE = 0; //image
                }
              }
            } 
          }


          if(element.ISBG == 1){
              bg.updateBackground(model);
              continue;
          }

          //프린트용 컴포넌트 객체 생성.
          const component = new DRComponent(model, this.MATCHTYPELIST, true);
          try {
            if(model.COMPONENT_TYPE == 2){
              await component.createQRCODETEMP(component);
            }else if(model.COMPONENT_TYPE == 3){
              await component.createPHOTOTEMP(component);
            }else if(model.COMPONENT_TYPE == 4){
              await component.createBARCODETEMP(component);
            }
          } catch (error) {
            // QR코드/바코드/포토 생성 실패시에도 컴포넌트는 추가 (기본 이미지로 표시됨)
            console.warn('컴포넌트 생성 중 일부 실패:', error);
          }
          bg.addComponent(component, false);

        }

      },



      getPrintWidth(wpx){
        if(wpx == 384){
          return 102;
        }else if(wpx == 264){
          return 70;
        }else if(wpx == 340){
          return 90;
        }else if(wpx == 793){
          return 210;
        }else{
          return 0;
        }
      },

      getPrintHeight(hpx){
        if(hpx == 603){
          return 160;
        }else if(hpx == 567){
          return 150;
        }else if(hpx == 463){
          return 122.5;
        }else if(hpx == 384){
          return 102;
        }else if(hpx == 313){
          return 83;
        }else if(hpx == 263){
          return 70;
        }else if(hpx == 191){
          return 50;

        }else if(hpx == 642){
          return 170;
        }else if(hpx == 510){
          return 135;

        }else{
          return 0;
        }
      },

      async printtest4040(){
        try {
          //input은 문제가 된다.. div로 변경해서 출력해야할듯.
          
          const width_mm  = this.getPrintWidth(this.DISPLAY_WIDTH);
        const height_mm = this.getPrintHeight(this.DISPLAY_HEIGHT);
        if(width_mm == 0 || height_mm == 0){
          this.$alert(this.$t("common_size"));
          return;
        }
        
        const top_div = document.createElement("div");

        const temp1 = document.createElement("div");
        
        temp1.style.margin = "0px";
        temp1.style.padding = "0px";
        
        temp1.style.height   = `${height_mm}mm`;
        temp1.style.width    = `${width_mm}mm`;
        //temp1.style.width    = `${this.DISPLAY_WIDTH}px`;
        temp1.style.overflow  = "hidden";

        const temp2 = document.createElement("div");
        
        temp2.style.margin = "0px";
        temp2.style.padding = "0px";

        temp2.style.height   = `${height_mm}mm`;
        temp2.style.width    = `${width_mm}mm`;
        //temp2.style.width    = `${this.DISPLAY_WIDTH}px`;
        temp2.style.overflow  = "hidden";
        temp2.style.transform  = "rotate(180deg)";

        const bg = new DRModel();
        bg.LAYOUT_WIDTH   = this.DISPLAY_WIDTH;
        bg.LAYOUT_HEIGHT  = this.DISPLAY_HEIGHT;
        bg.LAYOUT_POSX    = 0;
        bg.LAYOUT_POSY    = 0;
        bg.ISBG           = 1;  //bg
        bg.COMPONENT_TYPE = 0; 
        bg.BGTYPE = 0;
        bg.BGCOLOR = "FFFFFFFF";
        
        var front  = new DRBackground(bg, {}, this, true);
        var back   = new DRBackground(bg, {}, this, false);
        
        temp1.appendChild(front);
        temp2.appendChild(back);        

        // SELECT_DESIGN이 있으면 저장된 디자인을 사용, 없으면 현재 편집 내용 사용
        if(this.SELECT_DESIGN && this.SELECT_DESIGN.COMPONENT && this.SELECT_DESIGN.COMPONENT2) {
          await this.createPrintComponent(front, this.SELECT_DESIGN.COMPONENT.data);
          await this.createPrintComponent(back, this.SELECT_DESIGN.COMPONENT2.data);
        } else {
          // 현재 편집 중인 내용으로 출력
          var frontData = [this.drback.model];
          this.drback.component_list.forEach(cm => {
            frontData.push(cm.model);
          });
          
          var backData = [this.drback2.model];
          this.drback2.component_list.forEach(cm => {
            backData.push(cm.model);
          });

          await this.createPrintComponent(front, frontData);
          await this.createPrintComponent(back, backData);
        }

        const page_div = document.createElement("div");
        page_div.style.position  = "absolute";
        page_div.style.height    = `${height_mm*2}px`;
        page_div.style.width     = `${width_mm}px`;
        page_div.style.left      = "0px";
        page_div.style.top       = "0px";
        //page_div.style.overflow  = "hidden";

        page_div.appendChild(temp1);
        page_div.appendChild(temp2);

        top_div.appendChild(page_div);
        var printContents = top_div.outerHTML;
        //console.log("temp : " + printContents);

        var w = window.open();

        //폰트정보 넘겨주기
        this.fontlist.forEach(fontvalue=>{
          w.document.fonts.add(fontvalue);
        });

        w.document.write(printContents);
        w.document.write('<scr' + 'ipt type="text/javascript">' + 'window.onload = function() { window.print(); window.close(); };' + '</sc' + 'ript>');
        w.document.body.setAttribute("style", "-webkit-print-color-adjust: exact;");  //이거 해줘야 컬러와 이미지 출력됨.
        w.document.close(); // necessary for IE >= 10
        w.focus();
        
        } catch (error) {
          console.error('출력 오류:', error);
          this.$alert('출력 중 오류가 발생했습니다: ' + error.message);
        }
      },



      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.SEARCH_OPTION_IDX = null;
          this.SEARCH_OPTION_NAME = '';
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
          this.$session.set("OPTION_IDX", null);
          this.$session.set("OPTION_NAME",'');
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_OPTION_IDX = null;
          this.SEARCH_OPTION_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.$session.set("OPTION_IDX", null);
          this.$session.set("OPTION_NAME",'');
        }
        this.drback.clearBackground();
        this.drback2.clearBackground();
        this.loadpage();
      },

      //행사옵션 선택 콜백
      optionsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_OPTION_NAME = val1.NAME;
          this.SEARCH_OPTION_IDX  = val1.IDX;
          this.$session.set("OPTION_IDX", val1.IDX);
          this.$session.set("OPTION_NAME",val1.NAME);
        }else{
          this.SEARCH_OPTION_NAME = "";
          this.SEARCH_OPTION_IDX  = null;
          this.$session.set("OPTION_IDX", null);
          this.$session.set("OPTION_NAME", "");
        }
        this.drback.clearBackground();
        this.drback2.clearBackground();
        this.loadpage();
      },





      //base64 이미지 데이터를 파일로 변환
      dataURLtoFile(dataurl, fileName){
 
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], fileName, {type:mime});

      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.SEARCH_OPTION_IDX = null;
          this.SEARCH_OPTION_NAME = '';

        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;

          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.SEARCH_OPTION_IDX = null;
          this.SEARCH_OPTION_NAME = '';

        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.$session.set("OPTION_IDX", null);
        this.$session.set("OPTION_NAME", "");
        
        this.drback.clearBackground();
        this.drback2.clearBackground();

        this.loadpage();
        
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.SEARCH_OPTION_IDX = null;
          this.SEARCH_OPTION_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.$session.set("OPTION_IDX", null);
          this.$session.set("OPTION_NAME", "");
          this.drback.clearBackground();
          this.drback2.clearBackground();
          this.loadpage();
          
      },






      
    },

    beforeRouteLeave (to, from, next) {
      
      var undocnt1 = this.drback.getUndoSize();
      var undocnt2 = this.drback2.getUndoSize();
      if(undocnt1+undocnt2 > 0){
        this.$confirm(this.$t('design_msg10'))
        .then(() => {
          next();
        });
      }else{
        next();
      }

    },

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      //리사이즈 이벤트
      window.addEventListener('resize', this.changelayoutsize);

      // Del 키 이벤트 리스너 등록
      window.addEventListener('keydown', this.handleKeyDown);

      //edit_div에 DRBackground컴포넌트를 넣어준다.
      const edit_div  = document.getElementById("edit_div");
      const edit_div2 = document.getElementById("edit_div2");

      const bg = new DRModel();
      bg.LAYOUT_WIDTH   = 384;
      bg.LAYOUT_HEIGHT  = 463;
      bg.LAYOUT_POSX    = 0;
      bg.LAYOUT_POSY    = 0;
      bg.ISBG           = 1;  //bg
      bg.COMPONENT_TYPE = 0; 
      bg.BGTYPE = 0;
      bg.BGCOLOR = "FFFFFFFF";
      this.drback  = new DRBackground(bg, this.SELECT_ITEM, this, true);
      this.drback2 = new DRBackground(bg, this.SELECT_ITEM, this, false);
      edit_div.appendChild(this.drback);
      edit_div2.appendChild(this.drback2);

      this.SELECT_ITEM.splice(0, 1, bg);

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.SEARCH_OPTION_IDX  = this.$session.get("OPTION_IDX");
      this.SEARCH_OPTION_NAME = this.$session.get("OPTION_NAME");
      this.grade = this.$session.get("GRADE");

      this.changelayoutsize();

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인 해야해
        this.$router.push("Login");
        return;
      }

      //폰트 읽기
      this.$http.post(this.$host+'/api/FontList',{
        search_keyword:""
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

              const list = result.data.resultData;
              this.fontlist.splice(0, this.fontlist.length);   //데이터 초기화
              list.forEach(element => {
                //폰트 등록
                var temp_font = new FontFace(element.NAME, "url('"+element.FONTURL+"')");
                document.fonts.add(temp_font);
                this.fontlist.push(temp_font);
              });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
          
      });


    },

    beforeDestroy(){
      this.drback.destroy();
      this.drback2.destroy();
      window.removeEventListener('resize', this.changelayoutsize);
      // Del 키 이벤트 리스너 제거
      window.removeEventListener('keydown', this.handleKeyDown);
    },

    computed: {
    },

    watch: {

    },

    data () {
      
      return {
        useInfo:{},
        //dr background
        drback: null,
        drback2: null,

        //파일 업로드
        uploadFile : null,
        
        checkmove : false,
        bgcolorvalue : "00000000",
        textcolorvalue : "00000000",
        
        loading : false,    //로딩 표시

        items: [],

        SELECT_ITEM: [],  //서브 클래스에 참조타입으로 넘길려면 배열로 넘겨야 참조가 됨.
        DISPLAY_WIDTH:384,
        DISPLAY_HEIGHT:463,
        DISPLAY_X:0,
        DISPLAY_Y:0,

        BGTYPELIST: [
            {name:'컬러', name2:"Color",   value:0}
          , {name:'이미지', name2:"Image", value:1}
        ],

        ALIGNTYPELIST: [
            {name:'왼쪽',  name2:"Left",  value:"LEFT"}
          , {name:'오른쪽', name2:"Right", value:"RIGHT"}
          , {name:'가운데', name2:"Center", value:"CENTER"}
        ],

        COMPONENTTYPELIST: [
            {name:'텍스트', name2:"Text", value:1}
          , {name:'이미지', name2:"Image", value:0}
          , {name:'QR코드', name2:"QRCode", value:2}
          , {name:'포토',   name2:"Photo", value:3}
          , {name:'바코드', name2:"Barcode", value:4}
        ],

        MATCHTYPELIST: [
        ],

        isfront: true,      //명찰의 앞뒤 선택 구분
        CURRENT_FACE: true,  // 현재 활성 면 (true: 앞면, false: 뒷면)
        SELECT_DESIGN:null, //선택된 행사의 명찰디자인 객체

        SEARCH_COM_IDX: null,
        SEARCH_COM_NAME: '',
        SEARCH_EVENT_IDX: null,
        SEARCH_EVENT_NAME: '',
        SEARCH_OPTION_IDX: null,
        SEARCH_OPTION_NAME: '',
        grade : 0,
        
        fontlist: [],
        
        showSaveSnackbar: false,

      }
    }
  }
</script>
<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>  
  
  .face-border {
    border: solid 3px;
  }
  
  .face-active {
    border-color: #4e6ef7 !important;
  }
  
  .face-inactive {
    border-color: #e5e5e5 !important;
  }

  li {
    display: inline;
  }

  .pagination{
    margin: 0px;
  }
  
  
  body {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
  
  @media print {
      * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
      }
  }


</style>
